/*
 * ZEUS — el botón flotante de WhatsApp se aparta mientras se navega.
 *
 * En teléfono el botón queda fijo sobre el contenido y tapaba el título del
 * producto, "Completá tu look" y el resumen del carrito. Achicarlo ayudó pero
 * no alcanza: cualquier botón flotante termina sobre algún texto.
 *
 * Solución: mientras el cliente baja, el botón se corre fuera de la pantalla; en
 * cuanto sube o deja de desplazarse, vuelve. Así nunca tapa lo que se está
 * leyendo, pero sigue estando a un toque de distancia.
 *
 * Sólo actúa por debajo de 750 px: en escritorio hay margen de sobra y el botón
 * no molesta.
 */
(function () {
  'use strict';

  var MOBILE = '(max-width: 749px)';
  var HIDE_CLASS = 'zs-flotante--oculto';
  var SCROLL_THRESHOLD = 10; /* ignora el temblor del dedo */
  var MIN_SCROLL = 180; /* arriba de todo nunca se esconde */
  var REAPPEAR_DELAY = 700;

  var floating = document.querySelector('.zs-flotante');
  if (!floating) return;

  var lastY = window.scrollY;
  var idleTimer;
  var ticking = false;

  function show() {
    floating.classList.remove(HIDE_CLASS);
  }

  function evaluate() {
    ticking = false;

    if (!window.matchMedia(MOBILE).matches) {
      show();
      return;
    }

    var y = window.scrollY;
    var delta = y - lastY;

    if (Math.abs(delta) < SCROLL_THRESHOLD) return;
    lastY = y;

    if (delta > 0 && y > MIN_SCROLL) {
      floating.classList.add(HIDE_CLASS);
    } else {
      show();
    }

    /* Al frenar, el botón vuelve solo: si alguien baja y se queda leyendo, no
       tiene que hacer scroll hacia arriba para recuperarlo. */
    window.clearTimeout(idleTimer);
    idleTimer = window.setTimeout(show, REAPPEAR_DELAY);
  }

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(evaluate);
    },
    { passive: true }
  );

  /* Si se pasa a escritorio (o se rota el teléfono a horizontal), que no quede
     escondido para siempre. */
  window.addEventListener('resize', show, { passive: true });
})();
